import { throwParseError } from "@arktype/util";
import { writeUnexpectedCharacterMessage } from "./string/shift/operator/operator.js";
import { Scanner } from "./string/shift/scanner.js";
export const parseGenericParams = (def) => _parseGenericParams(new Scanner(def));
export const emptyGenericParameterMessage = "An empty string is not a valid generic parameter name";
const _parseGenericParams = (scanner) => {
    const param = scanner.shiftUntilNextTerminator();
    if (param === "")
        throwParseError(emptyGenericParameterMessage);
    scanner.shiftUntilNonWhitespace();
    const nextNonWhitespace = scanner.shift();
    return (nextNonWhitespace === "" ? [param]
        : nextNonWhitespace === "," ? [param, ..._parseGenericParams(scanner)]
            : throwParseError(writeUnexpectedCharacterMessage(nextNonWhitespace, ",")));
};
